import React from 'react';
import { getColor } from 'core/utils';

const OrderSoonIcon = (props) => (
	<svg
		width={40}
		height={24}
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M0 1a1 1 0 0 1 1-1h21.35a1 1 0 0 1 1 1v2.8H0V1Z" fill="#FF5D52" />
		<path
			d="M0 5.05h23.35v17.673a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V5.049Z"
			fill="#FED9D7"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M11.675 8.448c-.948 0-1.687.819-1.59 1.762l.583 5.674a1.013 1.013 0 0 0 2.015 0l.583-5.674a1.599 1.599 0 0 0-1.59-1.762Zm0 11.877a1.345 1.345 0 1 0 0-2.691 1.345 1.345 0 0 0 0 2.69Z"
			fill="#FF5D52"
		/>
	</svg>
);

export default OrderSoonIcon;